// Pricing Type Options with Article Numbers
export interface PricingTypeOption {
  articleNumber: string;
  articleName: string; // Translation key
  id: string;
  value: string; // For internal use (hour, day, week, month, agreed)
}

export const PRICING_TYPE_OPTIONS: PricingTypeOption[] = [
  { 
    articleNumber: '92', 
    articleName: 'HOURLY_WAGES', 
    id: '1',
    value: 'Tim'
  },
  { 
    articleNumber: '94', 
    articleName: 'PAYMENT_PER_DAY', 
    id: '2',
    value: 'Dag'
  },
  { 
    articleNumber: '95', 
    articleName: 'PAYMENT_PER_WEEK', 
    id: '3',
    value: 'vecka'
  },
  { 
    articleNumber: '96', 
    articleName: 'PAYMENT_PER_MONTH', 
    id: '4',
    value: 'm'
  },
  { 
    articleNumber: '97', 
    articleName: 'PAYMENT_AS_AGREED', 
    id: '5',
    value: 'a'
  }
];

// Helper function to get article number by value
export const getArticleNumberByValue = (value: string): string => {
  const option = PRICING_TYPE_OPTIONS.find(opt => opt.value === value);
  return option?.articleNumber || '92'; // Default to hourly
};

// Helper function to get option by value
export const getPricingTypeOption = (value: string): PricingTypeOption | undefined => {
  return PRICING_TYPE_OPTIONS.find(opt => opt.value === value);
};

// Helper function to get option by article number
export const getPricingTypeByArticleNumber = (articleNumber: string): PricingTypeOption | undefined => {
  return PRICING_TYPE_OPTIONS.find(opt => opt.articleNumber === articleNumber);
};
